import React from 'react';
import {View} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {Props} from './model';
import {useStyles} from '../../../../../shared/hooks/styles';
import {EvenOddList} from '../../../../../shared/components/evenOddList';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({snilsInfo: snilsInfo}: Props) => {
  const styles = useStyles(({theme}) => {
    return {
      container: {
        paddingBottom: theme.screen.bottomOffset,
      },
      sectionContainer: {
        marginTop: 21,
        paddingHorizontal: 24,
      },
      textStyle: {
        ...theme.fonts.small,
      },
      sectionTitle: theme.fonts.h2,
    };
  });
  return <EvenOddList testIDPrefix='other-docs-list' list={snilsInfo || []} title='Документы' hasPrivateData />;
};
